import {merge, Observable} from 'rxjs';

import IErrorsPayload from '../../../Player/Interfaces/IErrorsPayload';
import Playback       from '../../../State/Stores/Playback/Playback';

import createLoadErrorsStream       from './createLoadErrorsStream';
import createPlaybackErrorsStream   from './createPlaybackErrorsStream';
import createVideoErrorEventsStream from './createVideoErrorEventsStream';

/**
 * Creates and returns a single stream of errors from errors originating from
 * both load and playback logic, with error events dispatched from the
 * video element.
 */

const createMediaErrorsStream = (
    videoElement: HTMLVideoElement,
    loadErrors$: Observable<Error>,
    playbackStoreUpdate$: Observable<Playback>
): Observable<IErrorsPayload> =>
    merge(
        createLoadErrorsStream(loadErrors$),
        createVideoErrorEventsStream(videoElement, playbackStoreUpdate$),
        createPlaybackErrorsStream(playbackStoreUpdate$)
    );

export default createMediaErrorsStream;